<app-banner></app-banner>
<div class="d-flex justify-content-center align-items-center" style="height: 100%;">
  <div class="text-center shadow p-5 m-3" style="display: inline-block;">
    <img src="../../../../../assets/logo-login.png" style="width: 350px;max-width: 80%;" >
    <div class="col-12 mx-auto mt-5">
      <p class="lead mb-4" style="color: rgba(21, 32, 74, 1);">Login is required to access ACE. </p>

      <!-- <mat-checkbox>I agree with the <a href="" target="_blank">terms and conditions</a></mat-checkbox> -->

      <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mt-2">
        <button class="btn btn-primary btn-lg col-12" (click)="login()" *ngIf="!isOutage()">LOGIN WITH AIM</button>
      </div>
    </div>
  </div>
</div>
